module.exports = "/virtual-football-league/img/odd-games-active.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/odd-games-active.png
// module id = 140
// module chunks = 4